import './global.css'
import AppLayout from './layout/AppLayout'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Login from './pages/login'
import Mfa from './pages/Mfa'
import ResetCode from './pages/resetcode'
import ResetPw from './pages/resetpw'
import Dashboard from './pages/dashboard'
import Skills from './pages/skills'
import Team from './pages/team'
import Cases from './pages/cases'
import CaseDetails from './pages/CaseDetails'
import { CasesStateProvider } from './context/CasesStateContext'
import { ThemeProvider } from './context/ThemeContext'
import Connectors from './pages/connectors'
import Knowledge from './pages/knowledge'
import Admin from './pages/admin'

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/mfa" element={<Mfa />} />
          <Route path="/resetcode" element={<ResetCode />} />
          <Route path="/resetpw/:resetKey" element={<ResetPw />} />
          <Route element={<AppLayout />}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/teams" element={<Team />} />
            {/* Both cases routes share a keep-alive cache so returning from a case
                detail restores the list's scroll/data/filters (see CasesStateContext). */}
            <Route element={<CasesStateProvider />}>
              <Route path="/cases" element={<Cases />} />
              <Route path="/cases/:id" element={<CaseDetails />} />
            </Route>
            <Route path="/connect" element={<Connectors />} />
            <Route path="/knowledge" element={<Knowledge />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  )
}
